<template>
  <div id="presenza" class="presenza" v-loading="loading">
    <div class="top-block">
      <div class="presenze-header">
        <div class="search">
          <select-deleghe :searchFilter="searchFilter" :activateWatch="activateWatchSelect" @changeUser="changeUser"
            @endLoading="endLoading"></select-deleghe>
          <div class="select">
            <el-date-picker v-model="searchFilter.data" type="month" placeholder="Pick a month" format="MMM-yyyy"
              @change="changeMese()">
            </el-date-picker>
          </div>
        </div>
        <div class="status">
          <span>{{ getStato() }}</span>
        </div>
        <div class="action">
          <el-button class="WEB-button WEB-button-primary" style="width: 150px !important;" v-if="mese.chiuso === 'NO'"
            @click="saveMese">{{ $t('presenza.btn.regPresence').toUpperCase() }}</el-button>
          <el-button class="WEB-button WEB-button-primary" style="width: 150px !important;" v-if="mese.chiuso === 'NO'"
            @click="chiusuraMese">{{ $t('presenza.btn.closeMonth').toUpperCase() }}</el-button>
          <el-button class="WEB-button WEB-button-primary" style="width: 200px !important;" v-if="mese.cFisc !== ''"
            @click="attPred">{{ $t('presenza.btn.defActivity').toUpperCase() }}</el-button>
          <el-button class="WEB-button WEB-button-primary" style="width: 150px !important;" v-if="mese.cFisc !== ''"
            @click="stampaPres">{{ $t('presenza.btn.stampa').toUpperCase() }}</el-button>
        </div>
      </div>
      <div class="table-header">
        <span style="width: 70px">{{ $t("presenza.label.day") }}</span>
        <span style="width: 70px">{{ $t("presenza.label.hours") }}</span>
        <div :style="{ 'width': widthSelect + 'px' }" class="widthSelect">
          <span style="width: 19%">{{ $t("presenza.label.causal") }}</span>
          <span style="width: 19%">{{ $t("presenza.label.place") }}</span>
          <span style="width: 19%">{{ $t("presenza.label.company") }}</span>
          <span style="width: 19%">{{ $t("presenza.label.officeDepartment") }}</span>
          <span style="width: 19%">{{ $t("presenza.label.busyness") }}</span>
        </div>
        <span v-if="mese.auto == 'SI'" style="width: 70px">{{ $t("presenza.label.km") }}</span>
        <span style="width: 190px"></span>
      </div>
    </div>
    <div class="presenze-table" :style="{ height: (tableHeight - 115) + 'px' }">

      <div class="table-body" v-for="(giorno, index) in giorni" :id="index" :key="index">
        <row-day :activateWatch="activateWatch" :tipo="'mese'" :giorno="giorno" :indexGiorno="index" :causali="causali"
          :località="località" :aziende="aziende" :orario="orario" :auto="mese.auto" :mapAzi="mapAzi" :rowDay="rowDay"
          :widthSelect="widthSelect" :chiuso="mese.chiuso" @setToSave="setToSave" @changeAzienda="changeAzienda"
          @pulisciGiorno="pulisciGiorno" @checkCopia="checkCopia" @incollaGiorno="incollaGiorno"
          @sitGiorno="sitGiorno"></row-day>
      </div>
    </div>

    <!-- modal Details -->

    <el-dialog :title="getTitleModal()" :visible.sync="showModalDetails" class="custom-dialog" :append-to-body="true"
      custom-class="offset-lg-1 col-lg-22 offset-md-1 col-md-22 col-sm-24 col-24">


      <!--<el-dialog class="modal-riva" :title="getTitleModal()"
               :visible.sync="showModalDetails" :append-to-body="true"
               custom-class="dialog-presenza offset-lg-1 col-lg-22 offset-md-1 col-md-22 col-sm-24 col-24 no-padding">-->
      <div class="presenze-table" id="modalDialog">
        <div class="table-header">

          <span style="width: 70px">{{ $t("presenza.label.hours") }}</span>
          <div :style="{ 'width': widthSelectModal + 'px' }" class="widthSelect">
            <span style="width: 19%">{{ $t("presenza.label.causal") }}</span>
            <span style="width: 19%">{{ $t("presenza.label.place") }}</span>
            <span style="width: 19%">{{ $t("presenza.label.company") }}</span>
            <span style="width: 19%">{{ $t("presenza.label.officeDepartment") }}</span>
            <span style="width: 19%">{{ $t("presenza.label.busyness") }}</span>
          </div>
          <span v-if="modalGiorno.tipologia === 'Giorno' && mese.auto === 'SI'" style="width: 70px">{{
            $t("presenza.label.km")
            }}</span>
          <span style="width: 40px"></span>
        </div>
        <div class="table-body" v-for="(giorno, index) in modalGiorno.righe" :id="index" :key="index">
          <row-day :tipo="modalGiorno.tipologia" :giorno="giorno" :indexGiorno="index" :causali="causali"
            :località="località" :aziende="aziende" :orario="orario" :auto="mese.auto" :mapAzi="mapAzi" :rowDay="rowDay"
            :widthSelect="widthSelectModal" @changeAzienda="changeAzienda" @pulisciGiorno="pulisciGiorno"></row-day>
        </div>
        <div slot="footer" class="footer">
          <div class="col-24 no-padding">
            <div class="action">
              <el-button class="WEB-button WEB-button-alternative" @click="closeModalDetails">{{
                $t('presenza.btn.abort') }}</el-button>
              <el-button class="WEB-button WEB-button-primary"
                v-if="modalGiorno.tipologia === 'Giorno' && mese.chiuso === 'NO'" @click="saveGiorno">{{
                  $t('presenza.btn.salva').toUpperCase() }}</el-button>
              <el-button class="WEB-button WEB-button-primary" v-if="modalGiorno.tipologia === 'AttPred'"
                @click="saveAttPred">{{ $t('presenza.btn.salva').toUpperCase() }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import moment from 'moment'
import RowDay from './RowDay.vue'
import SelectDeleghe from './selectDelghe.vue'

export default {
  components: {
    SelectDeleghe,
    RowDay
  },
  watch: {
    '$mq.resize': 'resize',
    'showMessages.val': function (newVal, oldVal) {
      this.resize()
    }
  },
  props: ['tableHeight', 'showMessages'],
  name: 'Presenza',
  i18n: {
    messages: {
      it_IT: {
        presenza: {
          msg: {
            1902: 'Timeout Exception: no response received',
            1903: 'Request parameter error',
            confReg: 'Sei sicuro di voler Registrare le Presenze?',
            confCloseMonth: 'Sei sicuro di voler Chiudere il Mese?',
            copyDay: 'Copia Giorno',
            pastDay: 'Incolla Giorno',
            successCopyDay: 'Il giorno è stato copiato correttamente',
            confReopening: 'Sei sicuro di voler Riaprire i documenti selezionati?',
            abort: 'Operazione Annullata',
            opError: 'Operazione Non Consentita',
            selectDay: 'Selezionare prima il Giorno da Copiare',
            info: 'Avviso!',
            success: 'Successo!',
            warning: 'Attenzione!',
            error: 'Errore!',
            errorSaveDay: 'Errore giorno ',
            infoEditMulti: 'Usare il dettaglio per modificare e/o cancellare presenze multiple',
            confirmChangeMonth: 'Esistono presenze non salvate, procedendo verranno persi i dati inseriti. Vuoi Continuare?'
          },
          btn: {
            regPresence: 'Registra',
            closeMonth: 'Chiudi Mese',
            defActivity: 'Attività Predefinita',
            stampa: 'Stampa',
            abort: 'Annulla',
            changeMonth: 'Cambia Mese',
            salva: 'Salva'
          },
          label: {
            title: 'Presenze WEB',
            day: 'Giorno',
            hours: 'Ore',
            causal: 'Causale',
            place: 'Località',
            company: 'Azienda',
            officeDepartment: 'Ufficio / Reparto',
            busyness: 'Attività',
            km: 'Km',
            employee: 'Dipendente',
            date: 'Data',
            status: 'Stato',
            attPred: 'ATTIVITA PREDEFINITA',
            detGio: 'Dettaglio Giornaliero: ',
            chiuso: '[ CHIUSO ]',
            aperto: '[ APERTO ]'
          }
        }
      },
      en_GB: {
        presenza: {
          msg: {
            1902: 'Timeout Exception: no response received',
            1903: 'Request parameter error'
          }
        }
      },
      es_ES: {
        presenza: {
          msg: {
            1902: 'Excepción de tiempo de espera: no se recibió respuesta',
            1903: 'Parámetro en error',
            confReg: '¿Estás seguro de querer registrar las presencias?',
            confCloseMonth: '¿Estás seguro de querer cerrar el mes?',
            copyDay: 'Copiar día',
            pastDay: 'Pegar día',
            successCopyDay: 'Día copiado correctamente',
            confReopening: 'Êtes-vous sur de vouloir reouvrir les documents selectionnées?',
            abort: 'Operación cancelada',
            opError: 'Operación no permitida',
            selectDay: 'Seleccionar primero el día que desea copiar',
            info: '¡Aviso!',
            success: '¡Éxito!',
            warning: '¡Atención!',
            error: '¡Error!',
            errorSaveDay: 'Error en la fecha ',
            infoEditMulti: 'Usar el detalle para modificar o borrar datos de presencia múltiples',
            confirmChangeMonth: 'Existen datos de presencia sin guardar. Si continúa, perderá los datos introducidos. ¿Desea continuar?'
          },
          btn: {
            regPresence: 'Registrar',
            closeMonth: 'Cerrar el mes',
            defActivity: 'Actividad predefinida',
            stampa: 'Imprimir',
            abort: 'Anular',
            changeMonth: 'Cambiar el mes',
            salva: 'Guardar'
          },
          label: {
            title: 'WEB Presencias',
            day: 'Día',
            hours: 'Horas',
            causal: 'Motivo',
            place: 'Localización',
            company: 'Sociedad',
            officeDepartment: 'Oficina/Departamento',
            busyness: 'Actividad',
            km: 'Km',
            employee: 'Empleado',
            date: 'Fecha',
            status: 'País',
            attPred: 'Actividad predefinida',
            detGio: 'Detalle del día: ',
            chiuso: '[ CERRADO ]',
            aperto: '[ ABIERTO ]'
          }
        }
      },
      fr_FR: {
        presenza: {
          msg: {
            1902: 'Timeout Exception - Aucune reponse reçue',
            1903: 'Paramètre en erreur',
            confReg: 'Êtes-vous sur de vouloir enregistrer les presences?',
            confCloseMonth: 'Êtes-vous sur de vouloir fermer le mois?',
            copyDay: 'Copier jour',
            pastDay: 'Coller jour',
            successCopyDay: 'Le jour a été copié correctement.',
            confReopening: 'Êtes-vous sur de vouloir reouvrir les documents selectionnées?',
            abort: 'Operation annulée',
            opError: 'Operation interdite',
            selectDay: 'Selectionner d\'abord le jour à copier',
            info: 'Info!',
            success: 'Fait!',
            warning: 'Attention!',
            error: 'Erreur!',
            errorSaveDay: 'Erreur jour ',
            infoEditMulti: 'Utiliser le détail pour modifier ou éliminer les presences multiples',
            confirmChangeMonth: 'Ils existent des presences non sauvegardées, si vous continuez les données seront perdues. Souhaitez vous également continuer?'
          },
          btn: {
            regPresence: 'Enregistrer',
            closeMonth: 'Fermer le mois',
            defActivity: 'Activité par défaut',
            stampa: 'Imprimer',
            abort: 'Annuler',
            changeMonth: 'Changer mois',
            salva: 'Sauvegarder'
          },
          label: {
            title: 'WEB Présence',
            day: 'Jour',
            hours: 'Heures',
            causal: 'Présence/Absence',
            place: 'Lieu de travail',
            company: 'Société',
            officeDepartment: 'Bureau/département',
            busyness: 'Activité',
            km: 'Km',
            employee: 'Salarié',
            date: 'Date',
            status: 'Etat',
            attPred: 'Activité par défaut',
            detGio: 'Détail du jour: ',
            chiuso: '[ FERMÉ ]',
            aperto: '[ OUVERT ]'
          }
        }
      },
      de_DE: {
        presenza: {
          msg: {
            1902: 'Timeout Exception: no response received',
            1903: 'Request parameter error',
            confReg: 'Sind Sie sicher, dass Sie die Anwesenheiten erfassen möchten?',
            confCloseMonth: 'Sind Sie sicher, dass Sie den Monat schließen möchten?',
            copyDay: 'Den Tag kopieren',
            pastDay: 'Den Tag einfügen',
            successCopyDay: 'Tag wurde richtig kopiert',
            confReopening: 'Sind Sie sicher, dass Sie die ausgewählten Dokumente wiederöffnen möchten?',
            abort: 'Auftrag wurde abgebrochen',
            opError: 'Auftrag nicht erlaubt',
            selectDay: 'Zuerst den Tag auswählen, den man kopieren möchte',
            info: 'Warnung!',
            success: 'Den Auftrag wurde erfolgreich durchgeführt!',
            warning: 'Achtung!',
            error: 'Fehler!',
            errorSaveDay: 'Fehlertag ',
            infoEditMulti: 'Einzelaufstellung nutzen, um mehrere Daten der Anwesenheit zu modifizieren oder löschen',
            confirmChangeMonth: 'Einige Daten wurden nicht gespeichert. Wenn Sie weitergehen, könnten Sie die Daten verlieren. Möchten Sie weitergehen?'
          },
          btn: {
            regPresence: 'Aufzeichnung',
            closeMonth: 'Schließen',
            defActivity: 'Haupttätigkeit',
            stampa: 'Drucken',
            abort: 'Abbrechnen',
            changeMonth: 'Den Monat wechseln',
            salva: 'Gespeichert'
          },
          label: {
            title: 'AN- / Abwesenheiten',
            day: 'Tag',
            hours: 'Stunden',
            causal: 'Grund',
            place: 'Ort',
            company: 'Firma',
            officeDepartment: 'Büro/Abteilung',
            busyness: 'Tätigkeit',
            km: 'Km',
            employee: 'Mitarbeiter',
            date: 'Datum',
            status: 'Land',
            attPred: 'Haupttätigkeit',
            detGio: 'Tagesbericht: ',
            chiuso: '[ GESCHLOSSEN ]',
            aperto: '[ ÖFFNEN ]'
          }
        }
      }
    }
  },
  data() {
    return {
      a: 1,
      loading: false,
      causali: [],
      località: [],
      aziende: [],
      orario: [
        { 'valore': '0000', 'descrizione': '00:00' },
        { 'valore': '0030', 'descrizione': '00:30' },
        { 'valore': '0100', 'descrizione': '01:00' },
        { 'valore': '0130', 'descrizione': '01:30' },
        { 'valore': '0200', 'descrizione': '02:00' },
        { 'valore': '0230', 'descrizione': '02:30' },
        { 'valore': '0300', 'descrizione': '03:00' },
        { 'valore': '0330', 'descrizione': '03:30' },
        { 'valore': '0400', 'descrizione': '04:00' },
        { 'valore': '0430', 'descrizione': '04:30' },
        { 'valore': '0500', 'descrizione': '05:00' },
        { 'valore': '0530', 'descrizione': '05:30' },
        { 'valore': '0600', 'descrizione': '06:00' },
        { 'valore': '0630', 'descrizione': '06:30' },
        { 'valore': '0700', 'descrizione': '07:00' },
        { 'valore': '0730', 'descrizione': '07:30' },
        { 'valore': '0800', 'descrizione': '08:00' },
        { 'valore': '0830', 'descrizione': '08:30' },
        { 'valore': '0900', 'descrizione': '09:00' },
        { 'valore': '0930', 'descrizione': '09:30' },
        { 'valore': '1000', 'descrizione': '10:00' },
        { 'valore': '1030', 'descrizione': '10:30' },
        { 'valore': '1100', 'descrizione': '11:00' },
        { 'valore': '1130', 'descrizione': '11:30' },
        { 'valore': '1200', 'descrizione': '12:00' },
        { 'valore': '1230', 'descrizione': '12:30' },
        { 'valore': '1300', 'descrizione': '13:00' },
        { 'valore': '1330', 'descrizione': '13:30' },
        { 'valore': '1400', 'descrizione': '14:00' },
        { 'valore': '1430', 'descrizione': '14:30' },
        { 'valore': '1500', 'descrizione': '15:00' },
        { 'valore': '1530', 'descrizione': '15:30' },
        { 'valore': '1600', 'descrizione': '16:00' }
      ],
      mapAzi: {},
      mapCdc: {},
      listAttPred: [],
      searchFilter: {
        'employee': null,
        'currentEmployee': null,
        'data': '',
        'anno': '',
        'mese': '',
        'periodo': ''
      },
      mese: {
        cFisc: '',
        chiuso: '',
        auto: '',
        toSave: false
      },
      giorni: null,
      rowDay: {
        giornoCopia: {
          indexCheckCopia: '',
          righe: []
        },
        errorDays: [],
        savedDays: []
      },
      modalGiorno: {
        tipologia: '',
        giorno: '',
        mese: '',
        anno: '',
        righe: [],
        showMoreRows: false
      },
      blockActionMenu: false,
      showModalDetails: false,
      modalType: '',
      activateWatch: false,
      activateWatchSelect: false,
      widthSelect: 0,
      widthSelectModal: 0
    }
  },
  beforeMount: function () {
    //var loadDeleghe = true
    this.initialize()
    this.loading = true
  },
  beforeDestroy: function () {
  },
  methods: {
    initialize: function () {
      this.loading = true
      /*this.getPresDef()
      this.getCausale()
      this.getLocalita()
      this.getAzienda()
      for (var i = 0; i < this.listAttPred.length; i++) {
        if (this.aziende[this.mapAzi[this.listAttPred[i].azienda]] != undefined && this.aziende[this.mapAzi[this.listAttPred[i].azienda]].cdc.length === 0) {
          this.getCdc(this.listAttPred[i].azienda)
        }
      }*/
    },
    getPresDef: function () {
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/attPred', obj).then(response => {
        if (response.body.rc === 0) {
          this.listAttPred = response.body.data
        } else {
          this.listAttPred = []
        }
        this.getAzienda()
        this.calMese('0000', '00')
      })
    },
    /*getDeleghe: function () {
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/deleghe', obj).then(response => {
        if (response.body.rc === 0) {
          this.deleghe = response.body.data
        } else {
          this.deleghe = []
        }
        this.activateWatchSelect = true
      })
    },*/
    getCausale: function () {
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          'campo': 'CAU'
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          this.causali = response.body.data.filter(function (obj) {
            if (obj.seGestibile === 'SI') {
              return obj
            }
          })
        } else {
          this.causali = {}
        }
      })
    },
    getLocalita: function () {
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          'campo': 'LOC'
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          this.località = response.body.data
        } else {
          this.località = {}
        }
      })
    },
    getAzienda: function () {
      let _this = this
      this.aziende = []
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          'campo': 'AZR'
        }
      }
      this.$http.get('presenze/' + _this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          var index = 0
          this.aziende = response.body.data.map(function (obj) {
            obj.cdc = []
            _this.mapAzi[obj.valore] = index
            index++
            return obj
          })
          // } else {
          //  this.aziende = []
        }
        for (var i = 0; i < this.listAttPred.length; i++) {
          if (this.aziende[this.mapAzi[this.listAttPred[i].azienda]] != undefined && this.aziende[this.mapAzi[this.listAttPred[i].azienda]].cdc.length === 0) {
            this.getCdc(this.listAttPred[i].azienda)
          }
        }
      })
    },
    getCdc: function (azienda) {
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          'campo': 'CDC',
          'socCdc': azienda
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/tabelle', obj).then(response => {
        if (response.body.rc === 0) {
          this.aziende[this.mapAzi[azienda]].cdc = response.body.data
        } else {
          this.$message({
            showClose: true,
            message: 'Non ci sono CE-CO selezionabili per la società ' + azienda + '. Contattare l\'ufficio Amministrativo',
            type: 'error',
            duration: process.env.duration
          })
        }
      })
    },
    calMese: function (anno, mese) {
      this.loading = true
      this.$set(this.rowDay, 'errorDays', [])
      this.$set(this.rowDay, 'savedDays', [])
      this.$set(this, 'giorni', null)
      var obj = {
        params: {
          'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
          'anno': anno,
          'mese': mese
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/mese', obj).then(response => {
        if (response.body.rc === 0) {
          this.mese.toSave = false
          this.mese.auto = response.body.attrib.auto
          this.mese.chiuso = response.body.attrib.chiuso
          if (this.mese.auto == '') {
            this.mese.auto = response.body.attrib.auto
          }
          this.$set(this, 'giorni', [])
          this.activateWatch = true
          if (anno === '0000' && mese === '00') {
            var day = moment(response.body.attrib.anno + response.body.attrib.mese + '01', 'YYYYMMDD')
            this.searchFilter.data = day
            this.searchFilter.anno = response.body.attrib.anno
            this.searchFilter.mese = response.body.attrib.mese
          }
          // MAP PER COMPILARE/MODIFICARE I GIORNI DELMESE
          let arrayGiorni = []
          for (var i = 0; i < response.body.data.length; i++) {
            var obj = response.body.data[i]
            // CONTROLLO CHE ERA STATO FATTO PER NON COMPILARE I GIORNI SUCCESSIVI AD OGGI
            if (obj.azienda1 != undefined && obj.azienda1 != '' && this.mapCdc[obj.azienda1] === undefined) {
              this.mapCdc[obj.azienda1] = false
            }
            if (obj.festivo === 'NO' && obj.compilato === 'NO' && this.listAttPred.length === 1) {
              // GIORNO NON COMPILATO DA VALORIZZARE CON I DATI PREDEFINITI (1 SOLA RIGA)
              obj.ore = this.listAttPred[0].ore === '' ? null : this.orario.find(o => o.valore === this.listAttPred[0].ore)
              obj.causale = this.listAttPred[0].causale === '' ? null : this.causali.find(o => o.valore === this.listAttPred[0].causale)
              obj.localita = this.listAttPred[0].localita === '' ? null : this.località.find(o => o.valore === this.listAttPred[0].localita)
              obj.descrLoc = this.listAttPred[0].descrLoc
              //let azienda = this.aziende.find(o => o.valore === this.listAttPred[0].azienda)
              obj.azienda = this.listAttPred[0].azienda === '' ? null : this.aziende.find(o => o.valore === this.listAttPred[0].azienda)
              if (obj.azienda === undefined) obj.azienda = null
              obj.cdc = this.listAttPred[0].cdc === '' || obj.azienda == null ? null : {
                'valore': this.listAttPred[0].cdc,
                'valDesc': this.listAttPred[0].cdc + '-' + this.listAttPred[0].descrCdc
              }
              obj.multiriga = 'NO'
              obj.intervento = this.listAttPred[0].intervento
              obj.km = 0
              obj.toSave = 'NO'
            } else if (!(obj.compilato === 'SI' && obj.multiriga === 'NO')) {
              // TUTTI GLI ALTRI CASI TRANNE I GIORNI COMPILATI CON 1 SINGOLA RIGA PER GIORNO
              obj.ore = null
              obj.causale = null
              obj.localita = null
              obj.descrLoc = ''
              //obj.descrAzi = ''
              obj.azienda = null
              obj.cdc = null
              obj.intervento = ''
              obj.km = ''
              obj.toSave = 'NO'
              obj.multiriga = (obj.multiriga === 'SI' || (obj.festivo === 'NO' && this.listAttPred.length > 1)) ? 'SI' : 'NO'      //Verifico se Multiriga
              // obj.edit = false
            } else {
              obj.toSave = 'NO'
              obj.ore = obj.ore1 === '' ? null : this.orario.find(o => o.valore === obj.ore1)
              obj.causale = obj.causale1 === '' ? null : this.causali.find(o => o.valore === obj.causale1)
              obj.localita = obj.localita1 === '' ? null : this.località.find(o => o.valore === obj.localita1)
              obj.azienda = obj.azienda1 === '' ? null : this.aziende.find(o => o.valore === obj.azienda1)
              if (obj.azienda === undefined) obj.azienda = null
              obj.cdc = obj.cdc === '' || obj.cdc === undefined ? null : { 'valore': obj.cdc, 'valDesc': obj.cdc + '-' + obj.desCdc }
              obj.intervento = obj.intervento1
              obj.km = obj.km1
              delete obj['ore1']
              delete obj['azienda1']
              delete obj['causale1']
              delete obj['intervento1']
              delete obj['km1']
              delete obj['localita1']
              // obj.edit = false
            }
            obj.activateWatch = true
            arrayGiorni.push(obj)
          }
          this.giorni = arrayGiorni
          this.searchFilter.currentEmployee = response.body.attrib.codFisc
          this.mese.cFisc = response.body.attrib.codFisc
          this.mese.cognx = response.body.attrib.cognx
          this.mese.nomex = response.body.attrib.nomex
        } else {
          this.giorni = []
          //if (this.deleghe.length === 0) {
          this.$message({
            showClose: true,
            message: response.body.msg[0].msgTxt,
            type: 'error',
            duration: process.env.duration
          })
          //}
        }
        this.resize()
        this.loading = false
      })
    },
    changeAzienda: function (value) {
      if (this.aziende[this.mapAzi[value]].cdc.length === 0) {
        this.mapCdc[value] = true
        this.getCdc(value)
      }
    },
    changeMese: function () {
      let _this = this
      if (this.mese.toSave) {

        this.$confirm(this.$i18n.t('presenza.msg.confirmChangeMonth'), this.$i18n.t('presenza.msg.info'), {
          confirmButtonText: this.$i18n.t('presenza.btn.changeMonth'),
          cancelButtonText: this.$i18n.t('presenza.btn.abort'),
          type: 'info',
          callback: function (action) {
            if (action === 'confirm') {
              if (_this.searchFilter.data != undefined && _this.searchFilter.data != '') {
                var dt = moment(_this.searchFilter.data)

                _this.searchFilter.anno = dt.format('YYYY')
                _this.searchFilter.mese = dt.format('MM')
                //this.afterLoad = false
                _this.calMese(_this.searchFilter.anno, _this.searchFilter.mese)
              } else {
                //this.afterLoad = false
                _this.calMese('0000', '00')
              }
            } else {
              //this.afterLoad = false
              //this.resetDate = true
              let day = moment(_this.searchFilter.anno + '-' + _this.searchFilter.mese + '-01')
              _this.searchFilter.data = day
            }
          }
        })
      } else {
        if (this.searchFilter.data != undefined && this.searchFilter.data != '') {
          let dt = moment(this.searchFilter.data)

          this.searchFilter.anno = dt.format('YYYY')
          this.searchFilter.mese = dt.format('MM')
          //this.afterLoad = false
          this.calMese(this.searchFilter.anno, this.searchFilter.mese)
        } else {
          //this.afterLoad = false
          this.calMese('0000', '00')
        }
      }
    },
    changeUser: function () {
      //this.numDeleghe = numDeleghe
      this.getCausale()
      this.getLocalita()
      this.getPresDef()
    },
    stampaPres: function () {
      let codFisc = this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore
      let anno = this.searchFilter.anno
      let mese = this.searchFilter.mese
      let tipo = 'presenze'
      let url = ('download/presenze/' + this.$store.state.country + '?codFisc=' + codFisc + '&anno=' + anno + '&mese=' + mese + '&tipo=' + tipo + '&token=' + sessionStorage.getItem('token'))
      let win = window.open(process.env.baseUrlSpring + url, '_blank')
      win.focus()
    },
    chiusuraMese: function () {
      let _this = this
      let anno = _this.searchFilter.anno
      let mese = _this.searchFilter.mese
      this.$confirm(this.$i18n.t('presenza.msg.confCloseMonth'), this.$i18n.t('presenza.msg.info'), {
        confirmButtonText: this.$i18n.t('presenza.btn.closeMonth'),
        cancelButtonText: this.$i18n.t('presenza.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {

            let obj = {
              codFisc: _this.searchFilter.employee === null ? undefined : _this.searchFilter.employee.valore,
              utente: _this.searchFilter.employee === null ? undefined : _this.searchFilter.employee.valore,
              anno: anno,
              mese: mese
            }
            _this.$http.post('presenze/' + _this.$store.state.country + '/chiusMes', obj).then(response => {
              if (response.body.rc === 0) {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                _this.calMese(anno, mese)
              } else {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'warning',
                  duration: process.env.duration
                })
              }
            })
          } else {
            _this.$message({
              showClose: true,
              message: this.$i18n.t('presenza.msg.abort'),
              type: 'error',
              duration: process.env.duration
            })
          }
        }
      })
    },
    saveMese: function () {
      let _this = this
      this.$confirm(this.$i18n.t('presenza.msg.confReg'), this.$i18n.t('presenza.msg.info'), {
        confirmButtonText: this.$i18n.t('presenza.btn.regPresence'),
        cancelButtonText: this.$i18n.t('presenza.btn.abort'),
        type: 'info',
        callback: function (action) {
          if (action === 'confirm') {
            _this.$set(_this.rowDay, 'errorDays', {})
            _this.$set(_this.rowDay, 'savedDays', {})
            let numRec = 0
            let giorni = []

            for (let item of _this.giorni) {
              if (item.toSave === 'SI') {
                let km = '0000000' + item.km
                numRec++
                let obj = {
                  gg: item.num,
                  ore: (item.ore === null ? '0000' : item.ore.valore),
                  causale: (item.causale === null ? '' : item.causale.valore),
                  localita: (item.localita === null ? '' : item.localita.valore),
                  descrLoc: item.descrLoc,
                  azienda: (item.azienda === null ? '' : item.azienda.valore),
                  cdc: (item.cdc === null ? '' : item.cdc.valore),
                  intervento: item.intervento,
                  km: (km.slice((km.length - 7), km.length)),
                }
                giorni.push(obj)
              }
            }

            let obj = {
              codFisc: _this.searchFilter.employee === null ? undefined : _this.searchFilter.employee.valore,
              anno: _this.searchFilter.anno,
              mese: _this.searchFilter.mese,
              numRec: numRec,
              giorni: giorni
            }
            _this.$http.post('presenze/' + _this.$store.state.country + '/mese', obj).then(response => {
              if (response.body.rc === 0) {
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                _this.calMese(_this.searchFilter.anno, _this.searchFilter.mese)
              } else {
                // Messaggio di errore Salvataggio
                _this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
                var arrayErr = []
                var arraySav = []
                for (let i = 0; i < response.body.data.length; i++) {
                  if (response.body.data[i].ggErr != undefined) {
                    arrayErr[response.body.data[i].ggErr] = true
                    setTimeout(function (index) {
                      _this.$notify({
                        title: _this.$i18n.t('presenza.msg.errorSaveDay') + parseInt(response.body.data[index].ggErr),
                        message: response.body.data[index].descrErr,
                        type: 'error',
                        duration: process.env.duration
                      })
                    }, 200 * (i + 1), i)
                  } else if (response.body.data[i].ggSav != undefined) {
                    arraySav[response.body.data[i].ggSav] = true
                  }
                }
                _this.$set(_this.rowDay, 'errorDays', arrayErr)
                _this.$set(_this.rowDay, 'savedDays', arraySav)
              }
            })
          }
        }
      })
    },
    checkCopia: function (giorno, index) {
      if (index === this.rowDay.giornoCopia.indexCheckCopia) {
        // Svuoto la variabile temporanea
        this.$set(this.rowDay.giornoCopia, 'indexCheckCopia', '')
        this.$set(this.rowDay.giornoCopia, 'righe', [])
      } else if (giorno.multiriga === 'SI') {
        this.$set(this.rowDay.giornoCopia, 'indexCheckCopia', index)
        let obj = {
          params: {
            'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
            'anno': this.searchFilter.anno,
            'mese': this.searchFilter.mese,
            'giorno': giorno.num
          }
        }
        this.$http.get('presenze/' + this.$store.state.country + '/giorno', obj).then(response => {
          if (response.body.rc === 0) {
            let righe = []
            for (let i = 0; i < 8; i++) {
              let obj = {
                numRiga: (response.body.data.length > i && response.body.data[i].numRiga != undefined ? response.body.data[i].numRiga : ('00' + (i + 1)).slice(-2)),
                ore: (response.body.data.length > i && response.body.data[i].ore != undefined ? response.body.data[i].ore : '0000'),
                causale: (response.body.data.length > i && response.body.data[i].causale != undefined ? response.body.data[i].causale : ''),
                localita: (response.body.data.length > i && response.body.data[i].localita != undefined ? response.body.data[i].localita : ''),
                descrLoc: (response.body.data.length > i && response.body.data[i].descrLoc != undefined ? response.body.data[i].descrLoc : ''),
                azienda: (response.body.data.length > i && response.body.data[i].azienda != undefined ? response.body.data[i].azienda : ''),
                cdc: (response.body.data.length > i && response.body.data[i].cdc != undefined ? response.body.data[i].cdc : ''),
                intervento: (response.body.data.length > i && response.body.data[i].intervento != undefined ? response.body.data[i].intervento : ''),
                km: (response.body.data.length > i && response.body.data[i].km != undefined ? response.body.data[i].km : '0000000')
              }
              righe.push(obj)
            }
            this.$set(this.rowDay.giornoCopia, 'righe', righe)
          } else {
            this.$set(this.rowDay.giornoCopia, 'righe', [])
          }
        })
      } else {
        this.$set(this.rowDay.giornoCopia, 'indexCheckCopia', index)
      }
    },
    incollaGiorno: function (giorno) {
      let indexToCopy = this.rowDay.giornoCopia.indexCheckCopia
      if (indexToCopy === '') {
        this.$message({
          showClose: true,
          message: this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].presenza.msg.selectDay,
          type: 'warning',
          duration: process.env.duration
        })
      } else {
        if (this.giorni[indexToCopy].multiriga === 'SI') {

          let obj = {
            'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
            'anno': this.searchFilter.anno,
            'mese': this.searchFilter.mese,
            'giorno': giorno.num,
            'righe': this.rowDay.giornoCopia.righe
          }
          this.$http.post('presenze/' + this.$store.state.country + '/giorno', obj).then(response => {
            if (response.body.rc === 0) {
              // Mdoficiare il valore della riga
              let index = parseInt(this.modalGiorno.num) - 1
              giorno.multiriga = 'SI'
              giorno.ore = null
              giorno.causale = null
              giorno.localita = null
              giorno.descrLoc = ''
              giorno.azienda = null
              giorno.cdc = null
              giorno.aziCdc = [null, null]
              giorno.intervento = ''
              giorno.km = ''
              giorno.toSave = 'NO'

              this.$message({
                showClose: true,
                message: this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].presenza.msg.successCopyDay,
                type: 'success',
                duration: process.env.duration
              })
            } else {
              for (let i = 0; i < response.body.msg.length; i++) {
                this.$message({
                  showClose: true,
                  message: response.body.msg[i].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
          })
        } else {
          let gioToCopy = this.giorni[indexToCopy]
          giorno.ore = gioToCopy.ore === '' ? null : gioToCopy.ore
          giorno.causale = gioToCopy.causale === '' ? null : gioToCopy.causale
          giorno.localita = gioToCopy.localita === '' ? null : gioToCopy.localita
          giorno.descrLoc = gioToCopy.descrLoc
          giorno.azienda = gioToCopy.azienda === '' ? null : gioToCopy.azienda
          giorno.cdc = gioToCopy.cdc === '' ? null : gioToCopy.cdc
          giorno.intervento = gioToCopy.intervento
          giorno.km = gioToCopy.km
          giorno.multiriga = 'NO'
          giorno.toSave = 'SI'
          giorno.activateWatch = true
          this.mese.toSave = true
        }
      }
    }
    ,
    handleScroll: function (event) {
      this.blockActionMenu = window.pageYOffset >= 200 ? true : false
      // Any code to be executed
      // when the window is scrolled
    }
    ,
    getDesCausale: function (value) {
      for (let i = 0; i < this.causali.length; i++) {
        if (this.causali[i].valore === value) return this.causali[i].descrizione
      }
      return ''
    }
    ,
    getDesLoc: function (giorno, codLoc) {
      if (giorno.localita === 'E98' || giorno.localita === 'E99') {
        return giorno.descrLoc
      } else {
        giorno.localita === 'E98' || giorno.localita === 'E99'
        for (let i = 0; i < this.località.length; i++) {
          if (this.località[i].valore === codLoc) return this.località[i].descrizione
        }
        return ''
      }
    }
    ,
    getDesAziCdc: function (giorno) {
      let desAzienda = ''
      let desCdc = ''
      if (giorno.aziCdc != undefined) {
        for (let i = 0; i < this.aziende.length; i++) {
          if (this.aziende[i].valore === giorno.aziCdc[0]) {
            desAzienda = this.aziende[i].descrizione
            for (let j = 0; j < this.aziende[i].cdc.length; j++) {
              if (this.aziende[i].cdc[j].valore === giorno.aziCdc[1]) {
                desCdc = this.aziende[i].cdc[j].descrizione
                return desAzienda + ' / ' + desCdc
              }
            }
          }
        }
        return ''

      } else {
        return ''
      }
    }
    ,
    setToSave: function (giorno, tipo) {
      if (giorno.toSave === 'NO' && giorno.multiriga === 'NO') {
        giorno.toSave = 'SI'
        this.mese.toSave = true
      }
      if (tipo === 'causale' && (giorno.ore === '' || giorno.ore === null) && (giorno.causale !== '' && giorno.causale !== null)) {
        let ore = '0800'
        giorno.ore = { 'valore': ore, 'descrizione': this.getDescrizione(this.orario, ore) }
      }
    },
    pulisciGiorno: function (giorno) {
      if (giorno.multiriga === 'SI') {
        this.$message({
          showClose: true,
          message: this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].presenza.msg.infoEditMulti,
          type: 'warning',
          duration: process.env.duration
        })
      } else if (giorno.ifBloc === 'SI') {
        this.$message({
          showClose: true,
          message: this.$i18n.messages[this.$root.$i18n.locale.toLocaleString()].presenza.msg.opError,
          type: 'error',
          duration: process.env.duration
        })
      } else {
        giorno.ore = null
        giorno.causale = null
        giorno.localita = null
        giorno.descrLoc = ''
        giorno.azienda = null
        giorno.cdc = null
        giorno.aziCdc = [null, null]
        giorno.intervento = ''
        giorno.km = ''
        giorno.toSave = 'SI'
        giorno.activateWatch = true
        this.mese.toSave = true
      }
    },
    getStato: function () {
      if (this.mese.cFisc === '') {
        return ''
      } else if (this.mese.chiuso === 'SI') {
        return this.$i18n.t('presenza.label.status') + ' ' + this.$i18n.t('presenza.label.chiuso')
      } else {
        return this.$i18n.t('presenza.label.status') + ' ' + this.$i18n.t('presenza.label.aperto')
      }
    },
    getTitleModal: function () {
      if (this.modalGiorno.tipologia === 'Giorno') {
        let day = moment(this.modalGiorno.anno + '-' + this.modalGiorno.mese + '-' + this.modalGiorno.num)
        return this.$i18n.t('presenza.label.detGio') + day.format('dddd') + ' ' + parseInt(this.modalGiorno.num) + ' ' + day.format('MMMM') + ' ' + this.modalGiorno.anno
      } else {
        return this.$i18n.t('presenza.label.attPred')
      }
    },
    sitGiorno: function (giorno) {
      this.loading = true

      let codFisc = this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore
      let anno = this.searchFilter.anno
      let mese = this.searchFilter.mese
      let num = giorno.num

      this.$set(this.modalGiorno, 'tipologia', 'Giorno')
      this.$set(this.modalGiorno, 'anno', anno)
      this.$set(this.modalGiorno, 'mese', mese)
      this.$set(this.modalGiorno, 'num', num)
      this.$set(this.modalGiorno, 'righe', [])
      this.modalGiorno.showMoreRows = false

      let obj = {
        params: {
          'codFisc': codFisc,
          'anno': anno,
          'mese': mese,
          'giorno': giorno.num
        }
      }
      this.$http.get('presenze/' + this.$store.state.country + '/giorno', obj).then(response => {
        if (response.body.rc === 0) {
          this.modalGiorno.showMoreRows = response.body.data.length >= 4 ? true : false
          for (let i = 0; i < 8; i++) {
            let day = {
              ore: (response.body.data.length > i && response.body.data[i].ore != null && response.body.data[i].ore != '' ? this.orario.find(o => o.valore === response.body.data[i].ore) : null),
              causale: (response.body.data.length > i && response.body.data[i].causale != null && response.body.data[i].causale != '' ? this.causali.find(o => o.valore === response.body.data[i].causale) : null),
              localita: (response.body.data.length > i && response.body.data[i].localita != null && response.body.data[i].localita != '' ? this.località.find(o => o.valore === response.body.data[i].localita) : null),
              descrLoc: (response.body.data.length > i ? response.body.data[i].descrLoc : ''),
              azienda: (response.body.data.length > i && response.body.data[i].azienda != null && response.body.data[i].azienda != '' ? this.aziende.find(o => o.valore === response.body.data[i].azienda) : null),
              cdc: (response.body.data.length > i && response.body.data[i].cdc != null && response.body.data[i].cdc != '' ? {
                'valore': response.body.data[i].cdc,
                'valDesc': response.body.data[i].cdc + '-' + response.body.data[i].desCdc
              } : null),
              numRiga: ('00' + (i + 1)).slice(-2),
              km: (response.body.data.length > i ? response.body.data[i].km : ''),
              intervento: (response.body.data.length > i ? response.body.data[i].intervento : ''),
              sigla: giorno.sigla,
              activateWatch: true
            }
            this.modalGiorno.righe.push(day)
          }
        } else {
          for (let i = 0; i < 8; i++) {
            let day = {
              ore: (this.listAttPred.length > i && this.listAttPred[i].ore != null ? this.orario.find(o => o.valore === this.listAttPred[i].ore) : null),
              causale: (this.listAttPred.length > i && this.listAttPred[i].causale != null ? this.causali.find(o => o.valore === this.listAttPred[i].causale) : null),
              localita: (this.listAttPred.length > i && this.listAttPred[i].localita != null ? this.località.find(o => o.valore === this.listAttPred[i].localita) : null),
              descrLoc: (this.listAttPred.length > i ? this.listAttPred[i].descrLoc : ''),
              azienda: (this.listAttPred.length > i && this.listAttPred[i].azienda != null ? this.aziende.find(o => o.valore === this.listAttPred[i].azienda) : null),
              cdc: (this.listAttPred.length > i && this.listAttPred[i].cdc != null ? {
                'valore': this.listAttPred[i].cdc,
                'valDesc': this.listAttPred[i].cdc + '-' + this.listAttPred[i].descrCdc
              } : null),
              numRiga: ('00' + (i + 1)).slice(-2),
              intervento: (this.listAttPred.length > i ? this.listAttPred[i].intervento : ''),
              km: '',
              sigla: giorno.sigla,
              activateWatch: true
            }
            this.modalGiorno.righe.push(day)
          }
        }
        this.loading = false
        this.showModalDetails = true
        this.modalType = 'sitGiorno'
        this.$nextTick(() => {
          this.resize()
        })
      })
    },
    saveGiorno: function () {
      let nRighe = 0
      let firstRowComp = false
      let tmpRow = {}
      let righe = []
      for (let i = 0; i < this.modalGiorno.righe.length; i++) {
        nRighe += (this.modalGiorno.righe[i].ore === null ? 0 : 1)
        let km = this.modalGiorno.righe[i].km === null ? '0000000' : '0000000' + this.modalGiorno.righe[i].km
        let numRiga = '0' + (i + 1)

        let obj = {
          numRiga: numRiga.slice(numRiga.length - 2, numRiga.length),
          ore: (this.modalGiorno.righe[i].ore != null ? this.modalGiorno.righe[i].ore.valore : '0000'),
          causale: (this.modalGiorno.righe[i].causale != null ? this.modalGiorno.righe[i].causale.valore : ''),
          localita: (this.modalGiorno.righe[i].localita != null ? this.modalGiorno.righe[i].localita.valore : ''),
          descrLoc: this.modalGiorno.righe[i].descrLoc,
          azienda: (this.modalGiorno.righe[i].azienda != null ? this.modalGiorno.righe[i].azienda.valore : ''),
          cdc: (this.modalGiorno.righe[i].cdc != null ? this.modalGiorno.righe[i].cdc.valore : ''),
          intervento: this.modalGiorno.righe[i].intervento,
          km: (km.slice((km.length - 7), km.length))
        }
        righe.push(obj)
        // Se singola riga da 8 ore salvo i dati in un oggetto temporaneo
        if (this.modalGiorno.righe[i].ore != null && firstRowComp === false) {
          firstRowComp = true
          tmpRow.ore = this.modalGiorno.righe[i].ore
          tmpRow.causale = this.modalGiorno.righe[i].causale
          tmpRow.localita = this.modalGiorno.righe[i].localita
          tmpRow.descrLoc = this.modalGiorno.righe[i].descrLoc
          tmpRow.cdc = this.modalGiorno.righe[i].cdc
          tmpRow.intervento = this.modalGiorno.righe[i].intervento
          tmpRow.km = this.modalGiorno.righe[i].km
        }
      }
      let obj = {
        'codFisc': this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
        'anno': this.searchFilter.anno,
        'mese': this.searchFilter.mese,
        'giorno': this.modalGiorno.num,
        'righe': righe
      }
      this.$http.post('presenze/' + this.$store.state.country + '/giorno', obj).then(response => {
        if (response.body.rc === 0) {
          let index = parseInt(this.modalGiorno.num) - 1
          this.giorni[index].multiriga = (nRighe > 1 ? 'SI' : 'NO')
          this.giorni[index].ore = (nRighe > 1 ? null : tmpRow.ore)
          this.giorni[index].causale = (nRighe > 1 ? null : tmpRow.causale)
          this.giorni[index].localita = (nRighe > 1 ? null : tmpRow.localita)
          this.giorni[index].descrLoc = (nRighe > 1 ? '' : tmpRow.descrLoc)
          this.giorni[index].azienda = (nRighe > 1 ? null : tmpRow.azienda)
          this.giorni[index].cdc = (nRighe > 1 ? null : tmpRow.cdc)
          this.giorni[index].intervento = (nRighe > 1 ? '' : tmpRow.intervento)
          this.giorni[index].km = (nRighe > 1 ? '' : tmpRow.km)
          this.giorni[index].toSave = 'NO'

          this.modalType = ''
          this.showModalDetails = false
        } else {

          for (let i = 0; i < response.body.data.length; i++) {
            this.$message({
              showClose: true,
              message: response.body.data[i].ggErr + ': ' + response.body.data[i].descrErr,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
      })
    },
    attPred: function () {
      // ATTIVITA' PREDEFINITA
      this.loading = true
      this.$set(this.modalGiorno, 'tipologia', 'AttPred')
      this.$set(this.modalGiorno, 'righe', [])
      for (let i = 0; i < 8; i++) {
        let day = {
          ore: (this.listAttPred.length > i && this.listAttPred[i].ore != null ? this.orario.find(o => o.valore === this.listAttPred[i].ore) : null),
          causale: (this.listAttPred.length > i && this.listAttPred[i].causale != null ? this.causali.find(o => o.valore === this.listAttPred[i].causale) : null),
          localita: (this.listAttPred.length > i && this.listAttPred[i].localita != null ? this.località.find(o => o.valore === this.listAttPred[i].localita) : null),
          descrLoc: (this.listAttPred.length > i ? this.listAttPred[i].descrLoc : ''),
          azienda: (this.listAttPred.length > i && this.listAttPred[i].azienda != null ? this.aziende.find(o => o.valore === this.listAttPred[i].azienda) : null),
          cdc: (this.listAttPred.length > i && this.listAttPred[i].cdc != null ? {
            'valore': this.listAttPred[i].cdc,
            'valDesc': this.listAttPred[i].cdc + '-' + this.listAttPred[i].descrCdc
          } : null),
          numRiga: ('00' + (i + 1)).slice(-2),
          intervento: (this.listAttPred.length > i ? this.listAttPred[i].intervento : ''),
          activateWatch: true
        }
        this.modalGiorno.righe.push(day)
      }
      this.loading = false
      this.showModalDetails = true
      this.modalType = 'attPred'
      this.$nextTick(() => {
        this.resize()
      })
    },
    saveAttPred: function () {
      let numRighe = 0
      let righe = []

      for (let item of this.modalGiorno.righe) {
        if (item.ore != null && item.causale != null) {
          numRighe++
          let obj = {
            ore: (item.ore != null ? item.ore.valore : ''),
            causale: (item.causale != null ? item.causale.valore : ''),
            localita: (item.localita != null ? item.localita.valore : ''),
            descrLoc: item.descrLoc,
            azienda: (item.azienda != null ? item.azienda.valore : ''),
            cdc: (item.cdc != null ? item.cdc.valore : ''),
            intervento: item.intervento
          }
          righe.push(obj)
        }
      }

      let obj = {
        codFisc: this.searchFilter.employee === null ? undefined : this.searchFilter.employee.valore,
        numRighe: numRighe,
        riga: righe
      }
      this.$http.post('presenze/' + this.$store.state.country + '/attPred', obj).then(response => {
        if (response.body.rc === 0) {
          this.getPresDef()
          this.modalType = ''
          this.showModalDetails = false
        } else {

          for (let i = 0; i < response.body.msg.length; i++) {
            this.$message({
              showClose: true,
              message: response.body.msg[i].msgTxt,
              type: 'error',
              duration: process.env.duration
            })
          }
        }
      })
    },
    isDisabled: function (giorno) {
      if (giorno.edit === false) {
        return true
      } else if (giorno.ifBloc === 'SI' || giorno.multiriga === 'SI') {
        return true
      } else {
        return false
      }
    },
    resize: function (tipologia) {
      if (document.getElementById('presenza') !== null) {
        let width = document.getElementById('presenza').clientWidth
        this.widthSelect = this.mese.auto === 'SI' ? width - 435 : width - 365
        if (this.showModalDetails && this.modalType === 'sitGiorno') {
          let widthModal = document.getElementById('modalDialog').clientWidth
          this.widthSelectModal = this.mese.auto === 'SI' ? widthModal - 250 : widthModal - 170
        } else if (this.showModalDetails && this.modalType === 'attPred') {
          let widthModal = document.getElementById('modalDialog').clientWidth
          this.widthSelectModal = widthModal - 170
        }
      }
    },
    getDescrizione: function (obj, key) {
      for (let value of Object.values(obj)) {
        if (value.valore === key) {
          return value.descrizione
        }
      }
      return 'errore'
    },
    endLoading: function () {
      this.resize()
      this.loading = false
    },
    closeModalDetails: function () {
      this.showModalDetails = false
    }
  }
  ,
  created: function () {
    window.addEventListener('scroll', this.handleScroll)
  }
  ,
  destroyed: function () {
    this.$destroy()
    window.removeEventListener('scroll', this.handleScroll)
  }
  ,
  activated: function () {
    this.resize()
  }
}
</script>


<style lang="less">
@import "../../assets/less/general.less";

.presenza {
  height: 100%;
  min-width: 1250px;
  max-width: 100%;

  .top-block {
    background-color: white;
    width: 100%;
    z-index: 1;

    .presenze-header {
      .set-font(@color: @white; @size: 14px);
      //border: solid 1px darkgray;
      //margin: 15px 15px 15px 15px;
      //background-color: #f4f5f6;
      padding: 10px 14px 15px 14px;
      height: 75px;

      .search {
        padding: 0 !important;
        float: left;
        width: 430px;
        position: relative;

        .select {
          float: left;
          text-align: left;
          margin-right: 10px;

          .el-date-editor {
            width: 160px;

            .el-input__inner {
              border: none;
              border-bottom: 1px solid #e7e7e7;
              padding-right: 0;
              padding-left: 20px;
              height: 22px;
              line-height: 22px;
            }

            .el-input__prefix {
              line-height: 22px;
              left: -5px;

              .el-input__icon {
                line-height: 22px;
              }
            }

            .el-input__suffix {
              line-height: 22px;

              //left: -5px;
              .el-input__icon {
                line-height: 22px;
              }
            }
          }
        }
      }

      .status {
        position: relative;
        float: left;
        color: #606266;
      }

      .action {
        text-align: right;
      }
    }

    .table-header {
      .set-font(@color: @greenRiva, @family: 'os-semibold', @size: 13px);
      background-color: white;
      border-bottom: 1px solid @greenRiva;
      line-height: 22px;
      background-color: @white;
      text-align: left;

      span {
        display: inline-block;
        text-align: center;
        //text-transform: uppercase;
      }

      .widthSelect {
        display: inline-block;
      }
    }
  }
}

.presenze-table {
  overflow: auto;
  width: 100%;
  //margin-top: 155px !important;
  //margin-left: 15px;
  //margin-right: 15px;
  text-align: left;

  //background-color: #f4f5f7;
  .table-header {
    .set-font(@color: @greenRiva, @family: 'os-semibold', @size: 13px);
    background-color: white;
    border-bottom: 1px solid @greenRiva;
    line-height: 22px;
    background-color: @white;
    text-align: left;

    span {
      display: inline-block;
      text-align: center;
      //text-transform: uppercase;
    }

    .widthSelect {
      display: inline-block;
    }
  }

  .table-body {
    margin-top: 3px;
  }

  .action {
    text-align: right;

    .el-button {
      margin-top: 12px;
      margin-right: 10px;
    }
  }
}

/*.modal-riva {
    .el-dialog__header {
      border-bottom: none !important;
    }
    .el-dialog__body {
      .presenze-table {
        margin-top: 0px !important;
      }
      .footer {
        height: 35px;
        margin-top: 15px;
        .action {
          height: 35px;
        }
      }
    }
    .action {
      text-align: right;
    }
  }*/



.dialog-presenza {
  .presenze-table {
    background-color: #fff;
    border: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PresenzeWeb/Presenza.vue